import { formatMoney } from '@betterment/core';
import { ListRow, Separator, Text } from '@betterment/samba-react';
import { ActivityDrawerLayout } from '@betterment/shared-components/src/components/activity/components/drawer/common/ActivityDrawerLayout';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../graphql/fragments/activityItem.generated';
import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';

export const AdvisoryFee: React.FC<{
  item: NarrowTypename<ActivityItemFragment, 'ActivityItemFee'>;
}> = ({ item }) => (
  <ActivityDrawerLayout title="Advisory Fee">
    <DrawerListRow label="Account" value={item.subAccount.envelope.purpose?.name ?? item.subAccount.name} />
    <Separator />
    <DrawerListRow label="Amount" value={item.amount ? formatMoney(item.amount) : ''} />
    <Separator />
    {item.feeReason && (
      <ListRow css={{ px: '0', pb: 'space.200', pt: 'space.200' }}>
        <ListRow.LeadingContent>
          <Text variant="text100">Description</Text>
        </ListRow.LeadingContent>
        <ListRow.BottomContent>
          <Text variant="text50" color="text.weak">
            {item.feeReason}
          </Text>
        </ListRow.BottomContent>
      </ListRow>
    )}
  </ActivityDrawerLayout>
);
